import CrateBannerBg from "../../assets/images/cms/creat-game-bg.png";
import BenchImg from "../../assets/images/cms/bench-img-1.png";
import BenchLeft from "../../assets/images/cms/bench-left.png";
import BenchRight from "../../assets/images/cms/bench-right.png";
import BenchCenter from "../../assets/images/cms/bench-center.png";
import PlusIcon from "../../assets/images/cms/plus-icon.svg";
import SkyShapeBg from "../../assets/images/cms/sky-shape.png";
import AvtarOne from "../../assets/images/cms/boyStanding.svg";
import GirlAvtarStandImg from "../../assets/images/cms/girlStanding.svg";
import SeatAvtarMenImg from "../../assets/images/cms/seat-avtar-men.png";
import SeatAvtarGirlImg from "../../assets/images/cms/seat-avtar-girl.png";
import BannerLogo from "../../assets/images/home/banner-logo.png";
import { useState, useRef, useEffect, useCallback, Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TeamParticipantModals from "../../components/Modal/TeamParticipantModals";
import useAppDispatch from "../../hooks/useAppDispatch";
import { openModal } from "../../redux/slices/uiSlice";
import { getCharacterListAPI, getGameCategoryListAPI } from "../../api/user";
import { useMutation, useQuery } from "@tanstack/react-query";
import { createGameAPI, getLifelinesAPI } from "../../api/game";
import { SpinWheelModal } from "../../components/SpinWheel";
import useToast from "../../hooks/useToast";
import { useSelector } from "react-redux";
import type { RootState } from "../../redux/store";
import { useTranslation } from "react-i18next";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import SecondaryBtn from "../../components/button/SecondaryBtn";
import AddTeam from "../../components/Modal/AddTeam";
import BuyCreditsModal from "../../components/Modal/BuyCreditsModal";
import DeleteTeamModal from "../../components/Modal/DeleteTeamModal";
import DeleteParticipantModal from "../../components/Modal/DeleteParticipantModal";
import ClearCategoriesModal from "../../components/Modal/ClearCategoriesModal";
import type { Participant } from "../../types/participant";
import { socket } from "../../utils/socket";
import InviteCountdown from "../../components/InviteCountdown";
import { IoInformation } from "react-icons/io5";
import Loader from "../../components/Loader/Loader";
import SelectedCategoriesPanel from "../../components/SelectedCategoriesPanel/SelectedCategoriesPanel";
import { resolveCharacterUrlFromList, useStandingCharacterUrl } from "../../utils/charcter";

interface Team {
  team_name: string;
  participants: Participant[];
  lifelines: string[];
  team_profile: string;
}

interface GameData {
  game_name: string;
  number_of_teams: number;
  teams: Team[];
  game_categories: { category_id: string }[];
}

const plusIconSize = `
absolute
z-[30]
2xl:w-[2vw] lg:w-8 md:w-5 sm:w-4 w-2.5 
2xl:p-[0.10vw] xl:p-0.5 lg:p-1 p-[1px]
2xl:rounded-[0.1041vw] rounded-sm 2xl:border-[0.1041vw] md:border-2 border-1 border landscape:max-lg:border border-black cursor-pointer aspect-square justify-center items-center flex bg-[#97A4F2]
`;

// OLD PLUS ICON CLASSNAMES REMOVED HERE BECAUSE IT WAS NOT ALIGNED IN LINE
// /** 7 sitting slots on the left half of a full-width row */
// const plusIconClassnamesLeftBenchSitting: Record<number, string> = {
//   0: `${plusIconSize} xl:top-[43%] top-[43%] xl:start-[10.5%] start-[10.5%] `,
//   1: `${plusIconSize} xl:top-[39%] top-[39%] xl:start-[15.5%] start-[15.5%] `,
//   2: `${plusIconSize} xl:top-[34%] top-[34%] xl:start-[20.5%] start-[20.5%] `,
//   3: `${plusIconSize} xl:top-[29%] top-[29%] xl:start-[25.5%] start-[25.5%] `,
//   4: `${plusIconSize} xl:top-[25%] top-[25%] xl:start-[30.5%] start-[30.5%] `,
//   5: `${plusIconSize} xl:top-[21%] top-[21%] xl:start-[35.5%] start-[35.5%] `,
//   6: `${plusIconSize} xl:top-[17%] top-[17%] xl:start-[40%] start-[40%] `,
// };

// /** 7 sitting slots on the right half of a full-width row */
// const plusIconClassnamesRightBenchSitting: Record<number, string> = {
//   0: `${plusIconSize} xl:top-[17%] top-[17%] xl:end-[40%] end-[40%]`,
//   1: `${plusIconSize} xl:top-[21%] top-[21%] xl:end-[35.5%] end-[35.5%]`,
//   2: `${plusIconSize} xl:top-[25%] top-[25%] xl:end-[30.5%] end-[30.5%]`,
//   3: `${plusIconSize} xl:top-[29%] top-[29%] xl:end-[25.5%] end-[25.5%]`,
//   4: `${plusIconSize} xl:top-[34%] top-[34%] xl:end-[20.5%] end-[20.5%]`,
//   5: `${plusIconSize} xl:top-[39%] top-[39%] xl:end-[15.5%] end-[15.5%]`,
//   6: `${plusIconSize} xl:top-[43%] top-[43%] xl:end-[10.5%] end-[10.5%]`,
// };


/** 7 sitting slots on the left half of a full-width row */
const plusIconClassnamesLeftBenchSitting: Record<number, string> = {
  0: `${plusIconSize} xl:top-[43%] top-[43%] xl:start-[10.5%] start-[10.5%] `,
  1: `${plusIconSize} xl:top-[39%] top-[39%] xl:start-[15.5%] start-[15.5%] `,
  2: `${plusIconSize} xl:top-[35%] top-[35%] xl:start-[20.5%] start-[20.5%] `,
  3: `${plusIconSize} xl:top-[31%] top-[31%] xl:start-[25.5%] start-[25.5%] `,
  4: `${plusIconSize} xl:top-[27%] top-[27%] xl:start-[30.5%] start-[30.5%] `,
  5: `${plusIconSize} xl:top-[23%] top-[23%] xl:start-[35.5%] start-[35.5%] `,
  6: `${plusIconSize} xl:top-[19%] top-[19%] xl:start-[40%] start-[40%] `,
};

/** 7 sitting slots on the right half of a full-width row */
const plusIconClassnamesRightBenchSitting: Record<number, string> = {
  0: `${plusIconSize} xl:top-[19%] top-[19%] xl:end-[40%] end-[40%]`,
  1: `${plusIconSize} xl:top-[23%] top-[23%] xl:end-[35.5%] end-[35.5%]`,
  2: `${plusIconSize} xl:top-[27%] top-[27%] xl:end-[30.5%] end-[30.5%]`,
  3: `${plusIconSize} xl:top-[31%] top-[31%] xl:end-[25.5%] end-[25.5%]`,
  4: `${plusIconSize} xl:top-[35%] top-[35%] xl:end-[20.5%] end-[20.5%]`,
  5: `${plusIconSize} xl:top-[39%] top-[39%] xl:end-[15.5%] end-[15.5%]`,
  6: `${plusIconSize} xl:top-[43%] top-[43%] xl:end-[10.5%] end-[10.5%]`,
};


/** 7 sitting slots on the center bench (~50% width) */
const plusIconClassnamesCenterBenchSitting: Record<number, string> = {
  0: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[12%] start-[12%] `,
  1: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[23.5%] start-[23.5%] `,
  2: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[35%] start-[35%] `,
  3: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[47%] start-[47%] `,
  4: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[59%] start-[59%] `,
  5: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[70.5%] start-[70.5%] `,
  6: `${plusIconSize} xl:top-[33%] top-[33%] xl:start-[82%] start-[82%] `,
};

// 2xl:max-w-[5.5vw] xl:max-w-[95px] lg:max-w-[85px] md:max-w-[63px] sm:max-w-[45px] max-w-[30px]

/** Left half of a full-width bench row (7 sitting slots, local index 0–6 → participants[1–7]) */
const leftBenchCharacterClassnames = {
  0: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[8%] top-[12%] xl:start-[8.5%] start-[8.5%] z-10",
    achivementWraper:
      "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    // {
    //   disabled achivement css
    //   "2xl:border-[0.052vw] border border-black-400 2xl:rounded-[0.20vw] rounded-sm text-center bg-[#E7E6E6] shadow-[0px_1px_0px_0px_#A09C9B] 2xl:text-[0.625vw]/tight xl:text-sm/tight sm:text-xs/tight xs:text-[8px]/tight text-[5px]/tight landscape:max-lg:text-[5px]/tight font-bold text-[#706A6A] 2xl:py-[0.2084vw] sm:py-1 py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.78125vw] sm:px-3.5 xs:px-1.5 px-1 landscape:max-lg:px-1 2xl:min-w-[4.84vw]  md:min-w-[93px] sm:min-w-[70px] min-w-[40px] landscape:max-lg:min-w-[40px] 2xl:min-h-[1.67vw] md:min-h-8 sm:min-h-6 min-h-3 landscape:max-lg:min-h-3 rotate-x-12 inline-flex justify-center items-center text-nowrap px-4"
    // }
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight text-[5px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[60px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap ",
    timer:
      "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  1: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[4%] top-[7%] xl:start-[14%] start-[14%] z-10",
    achivementWraper:
      "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer:
      "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  2: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[0%] top-[2%] xl:start-[19%] sm:start-[19%] start-[19.5%] z-10",
    achivementWraper:
      "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer:
      "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  3: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-1vw] md:top-[-10px] sm:top-[-5px] top-0 xl:start-[24%] sm:start-[24%] start-[25%] z-10",
    achivementWraper:
      "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer:
      "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  4: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-1.5vw] md:top-[-20px] sm:top-[-15px] top-[-3px] xl:start-[29.5%] sm:start-[29.5%] start-[30%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText: "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  5: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-2vw] md:top-[-30px] sm:top-[-20px] top-[-5px] xl:start-[34.5%] sm:start-[34.5%] start-[35%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText: "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706]  2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  6: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-2.5vw] md:top-[-40px] sm:top-[-26px] top-[-10px] xl:start-[40%] start-[40%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText: "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full ltr:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
};

/** Right half of a full-width bench row (7 sitting slots, local index 0–6 → participants[1–7]) */
const rightBenchCharacterClassnames = {
  0: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-2.5vw] md:top-[-40px] sm:top-[-26px] top-[-10px] xl:end-[40%] end-[40%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  1: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-2vw] md:top-[-30px] sm:top-[-20px] top-[-5px] xl:end-[34.5%] sm:end-[34.5%] end-[35%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  2: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-1.5vw] md:top-[-20px] sm:top-[-15px] top-[-3px] xl:end-[29.5%] sm:end-[29.5%] end-[30%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  3: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[-1vw] md:top-[-10px] sm:top-[-5px] top-0 xl:end-[24%] sm:end-[24%] end-[25%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  4: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[0%] top-[2%] xl:end-[19%] sm:end-[19%] end-[19.5%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  5: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[4%] top-[7%] xl:end-[14%] end-[14%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] landscape:max-lg:max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap ",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
  6: {
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:top-[8%] top-[12%] xl:end-[8.5%] end-[8.5%] z-10",
    achivementWraper: "perspective-[250px] block absolute lg:top-[-10%] -top-6 start-1/2 -translate-x-1/2 rtl:translate-x-1/2",
    achivementText:
      "block 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm text-center bg-primary shadow-[0px_1px_0px_0px_#110706] 2xl:text-[0.42vw]/tight md:text-[8px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:max-w-[4.84vw]  md:max-w-[93px] sm:max-w-[70px] max-w-[40px] rotate-x-12 inline-block overflow-hidden text-nowrap whitespace-nowrap text-ellipsis",
    image: "w-full rtl:-scale-x-100 object-contain",
    name: "yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[1vw] -bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[4px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 2xl:max-w-[4vw] lg:max-w-[70px] md:max-w-[60px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap ",
    timer: "text-primary-orange 2xl:text-[0.5vw]/tight sm:text-sm/tight xs:text-[8px]/tight text-[6px]/tight landscape:max-lg:text-[6px]/tight",
  },
};

/** Center bench (~50% width): 7 sitting slots (local 0–6 → participants[1–7]) */
const centerBenchCharacterClassnames: Record<number, (typeof leftBenchCharacterClassnames)[0]> = {
  0: {
    ...leftBenchCharacterClassnames[0],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[8.5%] start-[8.5%] z-10",
  },
  1: {
    ...leftBenchCharacterClassnames[1],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[20%] start-[20%] z-10",
  },
  2: {
    ...leftBenchCharacterClassnames[2],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[32%] start-[32%] z-10",
  },
  3: {
    ...leftBenchCharacterClassnames[3],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[43.5%] start-[43.5%] z-10",
  },
  4: {
    ...leftBenchCharacterClassnames[4],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[56%] start-[56%] z-10",
  },
  5: {
    ...leftBenchCharacterClassnames[5],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[68%] start-[68%] z-10",
  },
  6: {
    ...leftBenchCharacterClassnames[6],
    div: "absolute w-full 2xl:max-w-[5vw] xl:max-w-[90px] lg:max-w-[80px] md:max-w-[60px] sm:max-w-[45px] max-w-[30px] 2xl:-top-[1.354vw] xl:-top-[20px] lg:-top-[5px] sm:-top-3.5 -top-1.5 xl:start-[80%] start-[80%] z-10",
  },
};

/** Seat 0: standing avatar beside bench (resolve URL via standing character list + profile_image) */
const leftBenchStandingPlayerWrapper =
  "absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] landscape:max-lg:top-[1vw] 2xl:-top-[0vw] xl:top-5 lg:top-11 md:top-0 -top-2 2xl:-start-[1.615vw] xl:-start-[1.615vw] xl:-start-[25px] sm:-start-3 -start-1";

const rightBenchStandingPlayerWrapper =
  "absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] landscape:max-lg:top-[1vw] 2xl:-top-[0vw] xl:top-5 lg:top-11 md:top-0 -top-2 2xl:-end-[1.615vw] xl:-end-[1.615vw] xl:-end-[25px] sm:-end-3 -end-1";

const centerBenchStandingPlayerWrapper =
  "absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] 2xl:-top-[3vw] xl:-top-9 lg:-top-1 md:-top-6 sm:-top-10 -top-8 landscape:max-lg:-start-[8vw] 2xl:-start-[6vw] xl:-start-[8vw] lg:-start-[95px] md:-start-[80px] sm:-start-15 -start-10";

const standingPlayerImageClass =
  "h-auto 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] sm:w-[90px] w-[50px] object-contain ltr:-scale-x-100 rtl:scale-x-100";

const standingPlayerImageClassRightBench =
  "h-auto 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] sm:w-[90px] w-[50px] object-contain ltr:scale-x-100 rtl:-scale-x-100";

const standingPlayerImageClassCenterBench =
  "h-auto 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] sm:w-[90px] w-[50px] object-contain ltr:-scale-x-100 rtl:scale-x-100";

const standingPlayerNameClass =
  "mt-1 px-1 text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight sm:text-[6px]/tight text-[4px]/tight font-bold text-black-300 max-w-[100px] text-center wrap-break-word whitespace-normal line-clamp-2";

const characters = {
  0: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  1: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  2: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  3: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  4: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  5: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
  6: {
    female: SeatAvtarGirlImg,
    male: SeatAvtarMenImg,
  },
};

const CreateGame = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const MAX_TEAMS = 4;
  const MIN_TEAMS = 2;
  /** 1 standing (slot 0) + 7 sitting on bench */
  const SLOTS_PER_TEAM = 8;
  const SITTING_SLOTS_PER_BENCH = 7;
  // After captain (standing), place sitters center-first, then alternate left/right for visual balance.
  const BALANCED_SITTING_ORDER: number[] = [3, 2, 4, 1, 5, 0, 6];
  const MAX_PARTICIPANTS_PER_TEAM = 8;
  const location = useLocation();
  const hasHydratedFromRouterStateRef = useRef(false);

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedCategoryCount, setSelectedCategoryCount] = useState<number | null>(4);
  const [isRandomMode, setIsRandomMode] = useState(false);
  const lastRandomizedRef = useRef<{ mode: boolean; teamCount: number } | null>(null);
  const [visibleCategoryDescriptionId, setVisibleCategoryDescriptionId] = useState<string | null>(null);
  const [isLifelineEnabled, setIsLifelineEnabled] = useState(true);

  const sanitizeCaptainParticipants = (participants: Participant[]): Participant[] => {
    let captainMarked = false;
    return participants.map((participant) => {
      if (participant.isCaptain && !captainMarked) {
        captainMarked = true;
        return { ...participant, isCaptain: true };
      }
      return { ...participant, isCaptain: false };
    });
  };


  const user = useSelector((state: RootState) => state.user.user);
  const isFreeTrial = Boolean(user && !user.is_free_game_played);

  useEffect(() => {
    if (isFreeTrial) {
      setSelectedCategoryCount(6);
    }
  }, [isFreeTrial]);

  const standingCharacterUrl = useStandingCharacterUrl(user?.profile_image);
  const { data: sittingCharacterListData } = useQuery({
    queryKey: ["characterList", "sitting"],
    queryFn: () => getCharacterListAPI({ type: "sitting" }),
    staleTime: 1000 * 60 * 30,
  });
  const sittingCharacters = (sittingCharacterListData as any)?.data?.characters || [];

  const { data: standingCharacterListData } = useQuery({
    queryKey: ["characterList", "standing"],
    queryFn: () => getCharacterListAPI({ type: "standing" }),
    staleTime: 1000 * 60 * 30,
  });
  const standingCharacters = (standingCharacterListData as any)?.data?.characters || [];
  // Validation errors state - stores translation keys, not translated strings
  const [errors, setErrors] = useState<{ gameName?: string; teamNames: { [key: number]: string } }>({
    teamNames: {},
  });

  const [roomName, setRoomName] = useState<string | null>(null);

  useEffect(() => {
    if (!user?.id) return;

    const handleConnect = () => {
      socket.emit("join_room", { user_id: user.id, is_host: true });
    };

    // Join immediately if already connected (e.g. after refresh)
    if (socket.connected) {
      handleConnect();
    }

    // Also join whenever a new socket connection is established
    socket.on("connect", handleConnect);

    socket.on("joined_room", (data: any) => {
      setRoomName(data.roomName);
    });

    socket.on("joined_participant", (data: any) => {
    });

    socket.on("invited_participant", (data: any) => {
    });

    socket.on("participant_joined", (data: any) => {

      const participantId = data?.participant_id as string | undefined;
      const hostId = data?.host_id as string | undefined;

      if (!participantId) return;

      // Optionally ensure this event is for the current host
      if (hostId && user.id && hostId !== user.id) {
        return;
      }

      // Update participant status from "invited" to "joined" in all teams
      const pid = String(participantId ?? "").trim();
      setGameData((prev) => ({
        ...prev,
        teams: prev.teams.map((team) => ({
          ...team,
          participants: team.participants.map((participant) =>
            String(participant.user_id ?? "").trim() === pid
              ? { ...participant, joinStatus: "joined" as const }
              : participant
          ),
        })),
      }));
    });

    return () => {
      socket.off("connect", handleConnect);
      socket.off("joined_room");
      socket.off("joined_participant");
      socket.off("invited_participant");
      socket.off("participant_joined");
    };
  }, [user?.id, socket.connected]);

  // Refs for scrolling to error fields
  const gameNameInputRef = useRef<HTMLInputElement>(null);
  const teamNameInputRefs = useRef<{ [key: number]: HTMLInputElement | null }>({});

  // Game state matching the API payload structure
  const [gameData, setGameData] = useState<GameData>({
    game_name: "",
    number_of_teams: 0,
    teams: [],
    game_categories: [],
  });
  const baseUrl = import.meta.env.VITE_BASE_CDN_URL;

  const { data: lifelinesData } = useQuery({
    queryKey: ["lifelines", i18n],
    queryFn: getLifelinesAPI,
  });

  const lifelines = lifelinesData?.data?.map((item: any) => ({
    ...item,
    image: `${baseUrl}/${item.image}`,
  }));

  // Modal state: null when closed, team index (0, 1, 2) when open for that team
  const [activeTeamModal, setActiveTeamModal] = useState<number | null>(null);

  const dispatch = useAppDispatch();
  const handleOpenPlayInfo = () => {
    dispatch(openModal("playInfo"));
  };
  const defaultBorder = "bg-white";

  const activeClasses = "border-primary-orange shadow-[0px_4px_0px_0px_#D76A4D] bg-primary-yellow";

  const activeCategoryClasses =
    "2xl:rounded-[0.625vw] rounded-xl border-primary-orange md:shadow-[inset_0px_4px_0px_0px_#D76A4D,inset_4px_0px_0px_0px_#D76A4D,inset_0px_-4px_0px_0px_#D76A4D,inset_-4px_0px_0px_0px_#D76A4D] shadow-[0px_2px_0px_0px_#D76A4D,2px_0px_0px_0px_#D76A4D,0px_-2px_0px_0px_#D76A4D,-2px_0px_0px_0px_#D76A4D] scale-101";
  // bg-primary-yellow
  // 2xl:rounded-[0.625vw] rounded-xl border-primary-orange md:shadow-
  // [0px_4px_0px_0px_#D76A4D] shadow-[0px_4px_0px_0px_#D76A4D] scale-101
  // const activeCategoryClasses =
  // "2xl:border-[0.079vw] border-[1.5px] border-black-300 2xl:rounded-[0.625vw] rounded-xl shadow-[0px_4px_0px_0px_#110706] border-primary-orange shadow-[0px_4px_0px_0px_#D76A4D] bg-primary-yellow";

  // Category search and pagination state
  const [categorySearch, setCategorySearch] = useState("");
  const [categories, setCategories] = useState<any[]>([]);
  // For UI only: masters (accordion headers) -> subcategories (same objects as `categories`)
  const [masterCategories, setMasterCategories] = useState<any[]>([]);
  const [expandedMasterIds, setExpandedMasterIds] = useState<string[]>([]);
  const preloadedCategoryImagesRef = useRef<Set<string>>(new Set());
  const [categoryListLoading, setCategoryListLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreCategories, setHasMoreCategories] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const categoryContainerRef = useRef<HTMLDivElement>(null);
  const searchTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const categoryGradientBg = {
    0: "bg-[linear-gradient(180deg,#00D2FF_0%,#3A7BD5_100%)]",
    1: "bg-[linear-gradient(180deg,#F2709C_0%,#FF9472_100%)]",
    2: "bg-[linear-gradient(180deg,#9BC5C3_0%,#616161_100%)]",
    3: "bg-[linear-gradient(180deg,#CBAD6D_0%,#D53369_100%)]",
    4: "bg-[linear-gradient(180deg,#F857A6_0%,#FF5858_100%)]",
    5: "bg-[linear-gradient(180deg,#38EF7D_0%,#11998E_100%)]",
  };

  // Preload category images (default and selected) so switching feels instant
  useEffect(() => {
    if (!categories || categories.length === 0) return;

    categories.forEach((cat: any) => {
      [cat?.image, cat?.image_selected].forEach((src) => {
        if (!src || typeof src !== "string") return;
        if (preloadedCategoryImagesRef.current.has(src)) return;

        const img = new Image();
        img.src = src;
        preloadedCategoryImagesRef.current.add(src);
      });
    });
  }, [categories]);

  // Fetch categories function
  const fetchCategories = async (page: number, search: string, append: boolean = false): Promise<void> => {
    try {
      if (append) {
        setIsLoadingMore(true);
      } else {
        setCategoryListLoading(true);
      }

      const response = await getGameCategoryListAPI({
        page,
        search: search.trim() || undefined,
      });

      if (response?.data) {
        const mastersFromApi: any[] = response.data;

        // Map master -> subcategories (and keep `categories` as a flat list for selection/removal panel).
        const mappedMasterCategories = mastersFromApi.map((master: any) => {
          const subcats: any[] = Array.isArray(master.categories) ? master.categories : [];
          const mappedSubcats = subcats.map((sub: any) => ({
            id: sub.id,
            image: sub.image,
            image_selected: sub.image_selected,
            categoryTitle: sub.name,
            description: sub.description || sub.name,
            path: `/category/${sub.id}`,
            isPlayed: !!sub.is_played,
          }));

          return {
            id: master.id,
            name: master.name,
            categories: mappedSubcats,
          };
        });

        const mappedFlatSubcategories = mappedMasterCategories.flatMap((m) => m.categories);

        setCategories((prevCategories) => (append ? [...prevCategories, ...mappedFlatSubcategories] : mappedFlatSubcategories));
        setMasterCategories((prevMasters) => (append ? [...prevMasters, ...mappedMasterCategories] : mappedMasterCategories));
        // Default-open every master on a fresh load/search; add new masters when appending pages.
        if (!append) {
          setExpandedMasterIds(mappedMasterCategories.map((m) => m.id));
        } else {
          setExpandedMasterIds((prev) => {
            const next = new Set(prev);
            mappedMasterCategories.forEach((m) => next.add(m.id));
            return Array.from(next);
          });
        }

        // Check if there are more pages (assuming 20 master categories per page)
        setHasMoreCategories(mastersFromApi.length === 20);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      useToast(t("createGame.error.failedToLoadCategories") || "Failed to load categories", "error");
    } finally {
      setCategoryListLoading(false);
      setIsLoadingMore(false);
    }
  };

  // Initial load and search effect
  useEffect(() => {
    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Reset pagination when search changes
    setCurrentPage(1);
    setHasMoreCategories(true);

    // Debounce search (500ms delay)
    // For initial load, fetch immediately if search is empty
    const delay = categorySearch.trim() === "" ? 0 : 500;

    searchTimeoutRef.current = setTimeout(() => {
      fetchCategories(1, categorySearch, false);
    }, delay);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [categorySearch, i18n.language]);

  // Scroll detection for infinite scroll
  useEffect(() => {
    let isFetching = false;

    const handleScroll = () => {
      if (!categoryContainerRef.current || isLoadingMore || !hasMoreCategories || categoryListLoading || isFetching) {
        return;
      }

      const container = categoryContainerRef.current;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const containerBottom = container.offsetTop + container.offsetHeight;

      // Check if user scrolled near the bottom (within 200px)
      if (scrollTop + windowHeight >= containerBottom - 200) {
        isFetching = true;
        setCurrentPage((prevPage) => {
          const nextPage = prevPage + 1;
          fetchCategories(nextPage, categorySearch, true)
            .then(() => {
              isFetching = false;
            })
            .catch(() => {
              isFetching = false;
            });
          return nextPage;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [categorySearch, isLoadingMore, hasMoreCategories, categoryListLoading]);

  const category = categories;

  // Update game name
  const updateGameName = (name: string) => {
    // Remove leading and trailing spaces
    const trimmedName = name.trimStart();
    setGameData((prev) => ({ ...prev, game_name: trimmedName }));
    // Show error if exceeds 20 characters
    if (trimmedName.length > 20) {
      setErrors((prev) => ({ ...prev, gameName: "createGame.error.gameNameCannotExceed20Characters" }));
    } else if (errors.gameName) {
      // Clear error when within limit
      setErrors((prev) => ({ ...prev, gameName: undefined }));
    }
  };

  // Update team name
  const updateTeamName = (teamIndex: number, name: string) => {
    const trimmedName = name.trimStart();

    // Check for duplicate team names (case-insensitive)
    const isDuplicate = gameData.teams.some((team, index) =>
      index !== teamIndex && team.team_name.trim().toLowerCase() === trimmedName.trim().toLowerCase()
    );

    if (isDuplicate && trimmedName.trim()) {
      // Set error for duplicate team name
      setErrors((prev) => ({
        ...prev,
        teamNames: {
          ...prev.teamNames,
          [teamIndex]: t("createGame.error.duplicateTeamName") || "A team with this name already exists",
        },
      }));
      return; // Don't update if duplicate
    }

    setGameData((prev) => {
      const newTeams = [...prev.teams];
      newTeams[teamIndex] = { ...newTeams[teamIndex], team_name: trimmedName };
      return { ...prev, teams: newTeams };
    });
    // Clear error when typing
    if (errors.teamNames[teamIndex]) {
      setErrors((prev) => {
        const newTeamNames = { ...prev.teamNames };
        delete newTeamNames[teamIndex];
        return { ...prev, teamNames: newTeamNames };
      });
    }
  };

  // Update team participants
  const updateTeamParticipants = (teamIndex: number, participants: Participant[]) => {
    const normalizedParticipants = sanitizeCaptainParticipants(participants);
    let updatedTeam: Team | null = null;
    setGameData((prev) => {
      const newTeams = [...prev.teams];
      updatedTeam = { ...newTeams[teamIndex], participants: normalizedParticipants };
      newTeams[teamIndex] = updatedTeam;
      return { ...prev, teams: newTeams };
    });
    // Immediately update selectedTeam if we're updating the currently selected team
    if (teamIndex === selectedTeamIndex && updatedTeam) {
      setSelectedTeam(updatedTeam);
    }
  };

  // Handle team deletion confirmation
  const handleConfirmDeleteTeam = () => {
    if (teamToDelete !== null) {
      removeTeam(teamToDelete);
      setTeamToDelete(null);
    }
  };

  const handleCancelDeleteTeam = () => {
    setTeamToDelete(null);
  };

  // Handle participant deletion confirmation
  const handleConfirmDeleteParticipant = () => {
    if (participantToDelete !== null) {
      removeParticipantFromTeam(participantToDelete.id);
      setParticipantToDelete(null);
    }
  };

  const handleCancelDeleteParticipant = () => {
    setParticipantToDelete(null);
  };

  // Remove team at specific index
  const removeTeam = (teamIndex: number) => {
    if (gameData.teams.length <= MIN_TEAMS) {
      return; // Don't allow removing if at minimum
    }
    setGameData((prev) => {
      const newTeams = prev?.teams?.filter((_, index) => index !== teamIndex);
      // Adjust number_of_teams if needed
      const newNumberOfTeams = Math.max(MIN_TEAMS, newTeams.length);
      return {
        ...prev,
        teams: newTeams,
        number_of_teams: newNumberOfTeams,
      };
    });
    // Clear errors for removed team
    setErrors((prev) => {
      const newTeamNames = { ...prev.teamNames };
      // Shift error indices for teams after the removed one
      const updatedErrors: { [key: number]: string } = {};
      Object.keys(newTeamNames).forEach((key) => {
        const idx = parseInt(key);
        if (idx < teamIndex) {
          updatedErrors[idx] = newTeamNames[idx];
        } else if (idx > teamIndex) {
          updatedErrors[idx - 1] = newTeamNames[idx];
        }
      });
      return { ...prev, teamNames: updatedErrors };
    });
  };

  // Toggle category selection
  const toggleCategorySelection = (categoryId: string) => {
    // Don't allow selection if category count limit is not set
    if (selectedCategoryCount === null) return;

    setSelectedCategories((prev) => {
      if (prev.includes(categoryId)) {
        return prev?.filter((id) => id !== categoryId);
      } else {
        // Check if we've reached the limit
        if (prev.length >= selectedCategoryCount) {
          return prev;
        }
        return [...prev, categoryId];
      }
    });
    // Also update gameData
    setGameData((prev) => {
      const exists = prev.game_categories.some((c) => c.category_id === categoryId);
      if (exists) {
        return {
          ...prev,
          game_categories: prev.game_categories?.filter((c) => c.category_id !== categoryId),
        };
      } else {
        // Check if we've reached the limit
        if (prev.game_categories.length >= selectedCategoryCount) {
          return prev;
        }
        return {
          ...prev,
          game_categories: [...prev.game_categories, { category_id: categoryId }],
        };
      }
    });

    // If in random mode, update ref to prevent auto-randomization from overriding manual changes
    if (isRandomMode) {
      lastRandomizedRef.current = {
        mode: isRandomMode,
        teamCount: gameData.teams.length,
      };
    }
  };

  // Clear all selected categories
  const handleClearAllCategories = () => {
    lastRandomizedRef.current = null;
    setSelectedCategories([]);
    setGameData((prev) => ({
      ...prev,
      game_categories: [],
    }));
    setIsRandomMode(false);
    setIsClearCategoriesModalOpen(false);
  };

  // Randomize category selection
  const randomizeCategories = () => {
    if (!categories || categories.length === 0 || selectedCategoryCount === null) return;

    const requiredCount = selectedCategoryCount;
    const availableCategories = categories.map((cat: any) => cat.id);

    // Shuffle array using Fisher-Yates algorithm
    const shuffled = [...availableCategories];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    // Select the required number of categories
    const randomSelected = shuffled.slice(0, Math.min(requiredCount, shuffled.length));

    // Update state
    setSelectedCategories(randomSelected);
    setGameData((prev) => ({
      ...prev,
      game_categories: randomSelected.map((id) => ({ category_id: id })),
    }));

    // Update ref to track this randomization
    lastRandomizedRef.current = {
      mode: isRandomMode,
      teamCount: gameData.teams.length,
    };
  };

  const navigate = useNavigate();

  const { mutate: createGame, isPending: isCreatingGame } = useMutation({
    mutationFn: createGameAPI,
    onSuccess: (data) => {
      if (data.status) {
        useToast(data.message, "success");
        navigate(`/game/${data.data.game_id}`);
      } else {
        useToast(data.message, "error");
      }
    },
    onError: (error) => {
      useToast(error.message, "error");
    },
  });

  const validateBeforeCategories = (): boolean => {
    let hasErrors = false;
    const newErrors: { gameName?: string; teamNames: { [key: number]: string } } = { teamNames: {} };

    // Validate game name (min 3 chars, max 20 chars)
    const gameName = gameData.game_name.trim();
    if (!gameName) {
      newErrors.gameName = "createGame.error.gameNameRequired";
      hasErrors = true;
    } else if (gameName.length > 20) {
      newErrors.gameName = "createGame.error.gameNameCannotExceed20Characters";
      hasErrors = true;
    }

    // Validate team names (min 3 chars)
    gameData.teams.forEach((team, index) => {
      const teamName = team.team_name.trim();
      if (!teamName) {
        newErrors.teamNames[index] = "createGame.error.teamNameRequired";
        hasErrors = true;
      } else if (teamName.length < 1) {
        newErrors.teamNames[index] = "createGame.error.teamNameMustBeAtLeast1Character";
        hasErrors = true;
      }
    });
    if (hasErrors) {
      setErrors(newErrors);
      const firstTeamError = Object.values(newErrors?.teamNames)[0];
      useToast(t(firstTeamError || newErrors.gameName || ""), "error");

      // Scroll to the first error field
      setTimeout(() => {
        if (newErrors.gameName && gameNameInputRef.current) {
          gameNameInputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          gameNameInputRef.current.focus();
        } else {
          // Find the first team with an error
          const firstTeamErrorIndex = Object.keys(newErrors.teamNames)[0];
          if (firstTeamErrorIndex !== undefined) {
            const teamIndex = parseInt(firstTeamErrorIndex);
            const teamInputRef = teamNameInputRefs.current[teamIndex];
            if (teamInputRef) {
              teamInputRef.scrollIntoView({ behavior: "smooth", block: "center" });
              teamInputRef.focus();
            }
          }
        }
      }, 100);

      return false;
    }
    if (gameData.teams.some((team) => team.participants.length === 0)) {
      useToast(t("createGame.error.pleaseAddParticipantsToAllTeams"), "error");
      // Scroll to the first team without participants and set the team to selected team index who don't have participants
      setTimeout(() => {
        const firstEmptyTeamIndex = gameData.teams.findIndex((team) => team.participants.length === 0);
        if (firstEmptyTeamIndex !== -1) {
          setSelectedTeamIndex(firstEmptyTeamIndex);
          setSelectedTeam(gameData.teams[firstEmptyTeamIndex]);
        }
        document.getElementById("addteam")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      return false;
    }

    // Clear errors if validation passes
    setErrors({ teamNames: {} });
    return true;
  };

  const handleSelectCategories = () => {
    if (!validateBeforeCategories()) {
      return;
    }
    document.getElementById("selectcategory")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const validateBeforeCreateGame = () => {
    if (!validateBeforeCategories()) {
      return false;
    }

    if (gameData.number_of_teams < MIN_TEAMS) {
      useToast(t("createGame.error.pleaseAddAtLeast2Teams"), "error");
      setTimeout(() => {
        document.getElementById("addteam")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      return false;
    }

    if (selectedCategoryCount === null) {
      useToast(t("createGame.error.pleaseSelectCategoryCount") || "Please select how many categories you want", "error");
      setTimeout(() => {
        document.getElementById("selectcategory")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      return false;
    }

    if (selectedCategories.length === 0) {
      useToast(t("createGame.error.pleaseSelectAtLeastOneCategory"), "error");
      setTimeout(() => {
        document.getElementById("selectcategory")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      return false;
    }

    if (selectedCategories.length !== selectedCategoryCount) {
      useToast(t("createGame.error.pleaseSelectExactly", { count: selectedCategoryCount }) || `Please select exactly ${selectedCategoryCount} categories`, "error");
      setTimeout(() => {
        document.getElementById("selectcategory")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      return false;
    }
    // if (selectedCategories.length > gameData.number_of_teams * 2) {
    //   useToast(t("createGame.error.pleaseSelectExactly", { count: gameData.number_of_teams * 2 }), "error");
    //   setTimeout(() => {
    //     document.getElementById("selectcategory")?.scrollIntoView({ behavior: "smooth", block: "center" });
    //   }, 100);
    //   return;
    // }

    // const res: any = validateCategories({
    //   game_categories: selectedCategories.map((category) => ({
    //     category_id: category,
    //   })),
    // });

    // // Validate before showing spinner
    // if (res?.status === false) {
    //   useToast(res?.message, "error");
    //   return;
    // }

    // if (!lifelines || lifelines.length === 0) {
    //   useToast(t("createGame.error.lifelinesNotLoaded"), "error");
    //   return false;
    // }
    if (user.total_available_games == 0) {
      useToast(t("createGame.error.noAvailableGamesInYourAccountDescription"), "error");
      return false;
    }

    return true;
  };

  const handleLifelinesComplete = useCallback((teamLifelines: { teamIndex: number; lifelineIds: string[] }[]) => {
    setGameData((prev) => {
      const hasChanges = prev.teams.some((team, index) => {
        const nextIds = teamLifelines[index]?.lifelineIds || [];
        if (team.lifelines.length !== nextIds.length) return true;
        return team.lifelines.some((id, idIndex) => id !== nextIds[idIndex]);
      });

      if (!hasChanges) return prev;

      return {
        ...prev,
        teams: prev.teams.map((team, index) => ({
          ...team,
          lifelines: teamLifelines[index]?.lifelineIds || [],
        })),
      };
    });
  }, []);

  const handleCreateGame = () => {
    if (user?.total_available_games <= 0) {
      useToast(t("createGame.error.noAvailableGamesInYourAccountDescription"), "error");
      return;
    }

    // if all the participants status are not joined, then show toast error with the name of the participant who is not joined
    const notJoinedParticipant = gameData.teams
      .find((team) => team.participants.some((p) => p.joinStatus !== "joined"))
      ?.participants.find((p) => p.joinStatus !== "joined");
    if (notJoinedParticipant) {
      useToast(
        t("createGame.error.pleaseJoinAllParticipantsDescription", { name: notJoinedParticipant.full_name }),
        "error"
      );
      return;
    }

    if (!validateBeforeCreateGame()) {
      return;
    }

    if (isLifelineEnabled && gameData.teams.some((team) => !Array.isArray(team.lifelines) || team.lifelines.length < 3)) {
      useToast(t("createGame.error.pleaseAddAtLeast3LifelinesToAllTeams"), "error");
      document.getElementById("lifeline-selection")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    const apiPayload = {
      ...gameData,
      device_type: "web",
      teams: gameData.teams.map((team) => ({
        ...team,
        participants: team.participants.map((p: any) => ({
          user_id: p.user_id ?? null,
          full_name: p.full_name,
          ...(p.email && { email: p.email }),
          ...(p.gender && { gender: p.gender }),
        })),
      })),
    };

    createGame(apiPayload);
  };

  const handleOpenTeamParticipantModal = (index?: number) => {
    if (user?.total_available_games <= 0) {
      useToast(t("createGame.error.noAvailableGamesInYourAccountDescription"), "error");
      return;
    }
    // Use provided index or fallback to selectedTeamIndex
    const teamIndex = index !== undefined ? index : selectedTeamIndex;
    setActiveTeamModal(teamIndex);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBuyCreditsModalOpen, setIsBuyCreditsModalOpen] = useState(false);
  const [editingTeamIndex, setEditingTeamIndex] = useState<number | null>(null);
  const [selectedTeamIndex, setSelectedTeamIndex] = useState(0);
  const [teamToDelete, setTeamToDelete] = useState<number | null>(null);
  const [participantToDelete, setParticipantToDelete] = useState<{ id: number; name: string } | null>(null);
  const [isClearCategoriesModalOpen, setIsClearCategoriesModalOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);
  const [participants, setParticipants] = useState([]);
  const [isJoinTeamSelectOpen, setIsJoinTeamSelectOpen] = useState(false);

  // Prefill a new game using the last finished game's teams/participants/lifelines.
  // This removes the need to manually re-add participants for consecutive games.
  useEffect(() => {
    if (hasHydratedFromRouterStateRef.current) return;

    const template = (location.state as any)?.lastGameTemplate;
    const templateTeams = template?.teams;
    if (!Array.isArray(templateTeams)) return;

    hasHydratedFromRouterStateRef.current = true;

    // Only apply if the template is within the allowed team constraints
    if (templateTeams.length < MIN_TEAMS || templateTeams.length > MAX_TEAMS) return;

    const normalizedTeams: Team[] = templateTeams.map((team: any, teamIndex: number) => ({
      team_name: String(team?.team_name ?? `Team ${teamIndex + 1}`),
      participants: (Array.isArray(team?.participants) ? team.participants : []).map((p: any, participantIndex: number) => ({
        // IMPORTANT: CreateGame UI uses `if (participant?.id)` so we must avoid `id = 0`.
        id: typeof p?.id === "number" && p.id > 0 ? p.id : teamIndex * 1000 + participantIndex + 1,
        user_id: p?.user_id ?? null,
        full_name: String(p?.full_name ?? ""),
        email: String(p?.email ?? ""),
        phone_number: p?.phone_number ?? undefined,
        country_code: p?.country_code ?? undefined,
        gender: p?.gender ?? null,
        profile_image: p?.profile_image ?? null,
        IQ: p?.IQ ?? null,
        joinStatus: "joined",
        isFromAPI: true,
        invitedAt: p?.invitedAt ?? new Date().toISOString(),
        apiFieldsFilled: p?.apiFieldsFilled,
        isCaptain: typeof p?.isCaptain === "boolean" ? p.isCaptain : participantIndex === 0,
      })),
      lifelines: (Array.isArray(team?.lifelines) ? team.lifelines : [])
        .map((l: any) => {
          if (typeof l === "string") return l;
          if (typeof l?.lifeline_id === "string") return l.lifeline_id;
          if (typeof l?.lifeline_id?._id === "string") return l.lifeline_id._id;
          if (typeof l?._id === "string") return l._id;
          if (typeof l?.id === "string") return l.id;
          return null;
        })
        .filter((id: string | null): id is string => Boolean(id)),
      team_profile: String(team?.team_profile ?? ""),
    }));

    setGameData({
      game_name: String(template?.game_name ?? ""),
      number_of_teams: normalizedTeams.length,
      teams: normalizedTeams,
      game_categories: [],
    });

    // Reset category/randomization state for a fresh "Play Again" setup.
    setSelectedCategories([]);
    setSelectedCategoryCount(isFreeTrial ? 6 : 4);
    setIsRandomMode(false);
    lastRandomizedRef.current = null;

    setSelectedTeamIndex(0);

    // Clear router state so refreshing the page does NOT re-apply the old template
    // (user changes should stay after refresh).
    navigate("/create-game", { replace: true });
  }, [location.state]);

  // Sync selectedTeam with gameData.teams[selectedTeamIndex] when teams change
  useEffect(() => {
    if (gameData.teams.length > 0) {
      if (selectedTeamIndex < gameData.teams.length) {
        // Always use latest team from gameData so UI reflects joinStatus etc. updates
        setSelectedTeam(gameData.teams[selectedTeamIndex]);
      } else {
        // If selectedTeamIndex is out of bounds, reset to last team
        const lastIndex = gameData.teams.length - 1;
        setSelectedTeamIndex(lastIndex);
        setSelectedTeam(gameData.teams[lastIndex]);
      }
    } else {
      setSelectedTeam(null);
    }
  }, [gameData.teams, selectedTeamIndex]);

  // Auto-randomize categories when switching to random mode or when team count changes
  useEffect(() => {
    const teamCount = gameData.teams.length;

    // Check if we need to randomize (e.g. just switched to random, or team count changed while in random)
    const ref = lastRandomizedRef.current;
    const shouldRandomize =
      isRandomMode &&
      selectedCategoryCount !== null &&
      category &&
      category.length > 0 &&
      teamCount >= MIN_TEAMS &&
      (ref === null || ref.mode !== true || ref.teamCount !== teamCount);

    if (shouldRandomize) {
      const requiredCount = selectedCategoryCount;
      const availableCategories = category.map((cat: any) => cat.id);

      // Shuffle array using Fisher-Yates algorithm
      const shuffled = [...availableCategories];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      // Select the required number of categories
      const randomSelected = shuffled.slice(0, Math.min(requiredCount, shuffled.length));

      // Update state
      setSelectedCategories(randomSelected);
      setGameData((prev) => ({
        ...prev,
        game_categories: randomSelected.map((id) => ({ category_id: id })),
      }));

      // Update ref to prevent re-randomization until mode or team count changes
      lastRandomizedRef.current = {
        mode: true,
        teamCount: teamCount,
      };
    }
  }, [isRandomMode, gameData.teams.length, category, selectedCategoryCount]);

  // Function to open modal for adding new team
  const handleOpenModal = (teamIndex?: number) => {
    if (user.total_available_games == 0) {
      setIsBuyCreditsModalOpen(true);
      return;
    }
    setEditingTeamIndex(null);
    setSelectedTeamIndex(teamIndex);
    setIsModalOpen(true);
  };

  // Function to open modal for editing existing team
  const handleEditTeam = (teamIndex: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setEditingTeamIndex(teamIndex);
    setIsModalOpen(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingTeamIndex(null);
  };

  // Remove participant by id (independent of currently selected team)
  const removeParticipantFromTeam = (participantId: number) => {
    setGameData((prev) => ({
      ...prev,
      teams: prev.teams.map((team) => ({
        ...team,
        participants: sanitizeCaptainParticipants(team.participants.filter((p) => p.id !== participantId)),
      })),
    }));
  };

  const hasJoinedAnyTeam = () => {
    if (!user?.id) return false;

    const userIdStr = String(user.id).trim();

    return gameData.teams.some((team) =>
      team.participants.some((p) => {
        const participantUserId = p.user_id ? String(p.user_id).trim() : null;
        const participantEmail = p.email?.trim().toLowerCase();
        const userEmail = user.email?.trim().toLowerCase();

        if (participantUserId && participantUserId === userIdStr) return true;
        if (participantEmail && userEmail && participantEmail === userEmail) return true;
        return false;
      })
    );
  };

  const handleJoinSelectedTeamAsHost = () => {
    if (!user?.id) {
      useToast("You must be logged in to join a team", "error");
      return;
    }

    if (gameData.teams.length === 0) {
      useToast("Please create at least one team first", "error",);
      return;
    }

    if (hasJoinedAnyTeam()) {
      useToast("You have already joined a team", "error");
      return;
    }
    setIsJoinTeamSelectOpen(true);
  };

  const handleConfirmJoinTeam = (teamIndex: number) => {
    const team = gameData.teams[teamIndex];
    if (!team) return;

    if (team.participants?.length >= MAX_PARTICIPANTS_PER_TEAM) {
      useToast(
        t("createGame.teamParticipantModal.maxParticipantsReached", { max: MAX_PARTICIPANTS_PER_TEAM }) ||
        `Maximum ${MAX_PARTICIPANTS_PER_TEAM} participants allowed per team`,
        "error"
      );
      return;
    }

    const newParticipant: Participant = {
      id: Date.now(),
      user_id: String(user.id),
      full_name: user.full_name || "",
      email: user.email || "",
      IQ: user.IQ || null,
      display_category_name: user.display_category_name || null,
      display_achievement_name: user.display_achievement_name || null,
      phone_number: (user as any).phone_number || undefined,
      country_code: (user as any).country_code || undefined,
      gender: (user as any).gender || null,
      profile_image: (user as any).profile_image || null,
      invitedAt: new Date().toISOString(),
      joinStatus: "joined",
      isFromAPI: true,
      apiFieldsFilled: {
        full_name: !!user.full_name,
        email: !!user.email,
        phone_number: !!(user as any).phone_number,
        country_code: !!(user as any).country_code,
      },
      isCaptain: (team.participants?.length || 0) === 0,
    };

    const updatedParticipants = [...(team.participants || []), newParticipant];
    updateTeamParticipants(teamIndex, updatedParticipants);
    setSelectedTeamIndex(teamIndex);
    setIsJoinTeamSelectOpen(false);
  };

  // Helper to get localized name from { en, ar } object
  type LocalizedName = { en: string; ar: string; _id?: string };
  const getLocalizedName = (obj: LocalizedName | null | undefined): string => {
    if (!obj) return "";
    return obj[currentLanguage as keyof LocalizedName] || obj.en;
  };

  const getCategoryBadgeDisplay = (user: any): string => {
    if (!user) return "";
    // const categoryName = getLocalizedName(user.display_category_name);
    // const badgeName = getLocalizedName(user.display_achievement_name);
    const IQ = user.IQ;
    return `${IQ ? `IQ: ${IQ}` : ""}`;
    // if (!categoryName && !badgeName && !IQ) return "";
    // return `${categoryName} ${badgeName ? ` ${badgeName} |` : ""} ${IQ ? `IQ: ${IQ}` : ""}`;
  };

  type BenchLayout = "fullRowLeft" | "fullRowRight" | "centerBench";

  const renderBenchSeatSlots = (teamIndex: number, layout: BenchLayout) => {
    const team = gameData.teams[teamIndex];
    if (!team) return null;
    const captain = team.participants.find((participant) => participant.isCaptain);
    const sittingParticipants = team.participants.filter((participant) => !participant.isCaptain);

    return Array.from({ length: SLOTS_PER_TEAM }).map((_, localIndex) => {
      const sittingOrderIndex = localIndex - 1;
      const sittingIdx =
        localIndex > 0
          ? BALANCED_SITTING_ORDER[sittingOrderIndex]
          : 0;

      const participant = localIndex === 0 ? captain : sittingParticipants[localIndex - 1];
      const sittingSpriteIdx =
        localIndex > 0 ? ((sittingIdx as number) % SITTING_SLOTS_PER_BENCH) as keyof typeof characters : 0;
      const spriteSet = characters[sittingSpriteIdx];

      const getSittingCharCfg = () => {
        const si = sittingIdx as keyof typeof leftBenchCharacterClassnames;
        if (layout === "fullRowLeft") return leftBenchCharacterClassnames[si];
        if (layout === "fullRowRight") return rightBenchCharacterClassnames[si];
        return centerBenchCharacterClassnames[si as keyof typeof centerBenchCharacterClassnames];
      };
      const standingWrapperClass =
        layout === "fullRowLeft"
          ? leftBenchStandingPlayerWrapper
          : layout === "fullRowRight"
            ? rightBenchStandingPlayerWrapper
            : centerBenchStandingPlayerWrapper;

      if (participant?.id !== undefined && participant?.id !== null) {
        const genderKey = participant.gender === "female" ? "female" : "male";

        // First seat: standing character beside the bench (standing asset from profile)
        if (localIndex === 0) {
          const standingSrc =
            resolveCharacterUrlFromList(participant?.profile_image, standingCharacters) ||
            (participant.gender === "female" ? GirlAvtarStandImg : AvtarOne);

          const standingImgClass =
            layout === "fullRowRight"
              ? standingPlayerImageClassRightBench
              : layout === "centerBench"
                ? standingPlayerImageClassCenterBench
                : standingPlayerImageClass;

          return (
            <div key={`bench-t${teamIndex}-s${localIndex}`} className={standingWrapperClass}>
              {getCategoryBadgeDisplay(participant) && (
                <span className="perspective-[250px] relative z-10 xl:mb-[0.5vw] md:px-4 px-1 mb-1 block w-full text-center">
                  <span
                    className={`inline-block max-w-full 2xl:border-[0.052vw] border border-black-300 2xl:rounded-[0.20vw] rounded-sm bg-primary xl:px-[0.208vw] xl:py-[0.104vw] px-1 py-0.5 2xl:text-[0.42vw]/tight sm:text-[8px]/tight text-[4px]/tight font-bold text-black-300 shadow-[0px_1px_0px_0px_#110706] ${participant?.gender === "female" ? "bg-[#97A4F2]!" : "bg-primary"}`}
                  >
                    {getCategoryBadgeDisplay(participant)}
                  </span>
                </span>
              )}

              <img src={standingSrc} alt="" className={standingImgClass} />
              <div className="yellow-wawe-shape light-wawe-shape absolute 2xl:-bottom-[3vw] xl:-bottom-[60px] lg:-bottom-12 -bottom-8 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 bg-center bg-[length:100%_100%] bg-no-repeat text-center 2xl:text-[0.625vw]/tight xl:text-xs/tight md:text-[9px]/tight text-[5px]/tight font-bold text-black-300 2xl:py-[0.3vw] py-0.5 landscape:max-lg:py-0.5 2xl:px-[0.208vw] sm:px-1 px-0.5 xl:max-w-[5.469vw] sm:max-w-[80px] max-w-[40px] 2xl:min-h-[1vw] md:min-h-8 sm:min-h-6 min-h-3 perspective-[250px] block overflow-hidden text-center text-nowrap whitespace-nowrap">
                <div className="flex items-center w-full 2xl:gap-[0.208vw] sm:gap-1 gap-0.5">
                  <div className="flex flex-col flex-1 min-w-0 items-center justify-center 2xl:gap-[0.208vw] gap-0.5">
                    <span className={standingPlayerNameClass}>{participant?.full_name}</span>
                    <InviteCountdown
                      key={`${participant?.id}-${participant?.joinStatus}`}
                      invitedAt={participant?.invitedAt}
                      joinStatus={participant?.joinStatus}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setParticipantToDelete({ id: participant.id, name: participant.full_name });
                    }}
                    className="shrink-0 flex items-center justify-center 2xl:w-[1vw] 2xl:h-[1vw] lg:w-4 lg:h-4 md:w-3 md:h-3 sm:w-2.5 w-1.5 sm:h-2.5 h-1.5 bg-primary-orange 2xl:border-[0.104vw] border border-black-300 2xl:rounded-[0.26vw] sm:rounded-sm rounded-xs sm:shadow-[0px_2px_0px_#110706] shadow-[0px_0px_0px_#110706]"
                    aria-label="Remove participant"
                  >
                    <svg
                      className="2xl:w-[0.7vw] 2xl:h-[0.7vw] lg:w-3 lg:h-3 md:w-3 md:h-3 sm:w-2.5 w-1 sm:h-2.5 h-1 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          );
        }

        const charCfg = getSittingCharCfg();

        return (
          <div key={`bench-t${teamIndex}-s${localIndex}`} className={charCfg.div}>
            {getCategoryBadgeDisplay(participant) && (
              <span className={charCfg.achivementWraper}>
                <span
                  className={`${charCfg.achivementText} ${participant?.gender === "female" ? "bg-[#97A4F2]!" : "bg-primary"}`}
                >
                  {getCategoryBadgeDisplay(participant)}
                </span>
              </span>
            )}

            <img
              src={
                resolveCharacterUrlFromList(participant?.profile_image, sittingCharacters) ||
                spriteSet[genderKey]
              }
              alt=""
              className={charCfg.image}
            />
            <span className={`${charCfg.name} relative flex items-center justify-center`}>
              <span className="flex items-center w-full 2xl:gap-[0.208vw] sm:gap-1 gap-0.5">
                <div className="flex flex-col flex-1 min-w-0 items-center justify-center 2xl:gap-[0.208vw] gap-0.5">
                  <span className="block w-full text-center wrap-break-word whitespace-normal line-clamp-2">
                    {participant?.full_name}
                  </span>

                  <InviteCountdown
                    key={`${participant?.id}-${participant?.joinStatus}`}
                    invitedAt={participant?.invitedAt}
                    joinStatus={participant?.joinStatus}
                  />
                </div>
                <div className="flex flex-col items-center 2xl:gap-[0.208vw] gap-0.5">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setParticipantToDelete({ id: participant.id, name: participant.full_name });
                    }}
                    className="flex-shrink-0 flex items-center justify-center 2xl:w-[1vw] 2xl:h-[1vw] lg:w-4 lg:h-4 md:w-3 md:h-3 sm:w-2.5 w-1.5 sm:h-2.5 h-1.5 bg-primary-orange 2xl:border-[0.104vw] border-[1px] border-black-300 2xl:rounded-[0.26vw] sm:rounded-sm rounded-xs 2xl:shadow-[0px_0.156vw_0px_#110706] sm:shadow-[0px_2px_0px_#110706] shadow-[0px_0px_0px_#110706] transition-all z-10"
                    aria-label="Remove participant"
                  >
                    <svg
                      className="2xl:w-[0.7vw] 2xl:h-[0.7vw] lg:w-3 lg:h-3 md:w-3 md:h-3 sm:w-2.5 w-1 sm:h-2.5 h-1 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </span>
            </span>
          </div>
        );
      }

      /* Standing slot (0): no plus — add first player via team modal / flow */
      // if (localIndex === 0) {
      //   return (
      //     <button
      //       key={`bench-t${teamIndex}-s0`}
      //       type="button"
      //       onClick={() => handleOpenTeamParticipantModal(teamIndex)}
      //       className={`${standingWrapperClass} group bg-red *:

      //       absolute z-20 flex flex-col items-center 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-[70px] w-[40px] landscape:max-lg:top-[1vw] 2xl:top-[6vw] xl:top-[8vw] lg:top-11 md:top-0 -top-2 2xl:-start-[2vw] xl:-start-[2vw] sm:-start-3 -start-1

      //       `}
      //     >
      //       <div className="flex flex-col items-center gap-1">
      //         <img src={PlusIcon} alt="" className="2xl:w-[2.5vw] xl:w-8 w-5 h-auto" />
      //         <span className="rounded-sm border border-black-300 bg-primary-yellow px-1 py-0.5 text-[8px] font-bold uppercase tracking-wide text-black-300 2xl:text-[0.45vw]">
      //           Add Captain
      //         </span>
      //       </div>
      //     </button>
      //   );
      // }

      let plusClass: string;
      if (layout === "fullRowLeft") {
        plusClass = plusIconClassnamesLeftBenchSitting[sittingIdx];
      } else if (layout === "fullRowRight") {
        plusClass = plusIconClassnamesRightBenchSitting[sittingIdx];
      } else {
        plusClass = plusIconClassnamesCenterBenchSitting[sittingIdx];
      }

      return (
        <button
          key={`bench-t${teamIndex}-s${localIndex}`}
          type="button"
          onClick={() => handleOpenTeamParticipantModal(teamIndex)}
          className={plusClass}
        >
          <img src={PlusIcon} alt="" className="w-full h-auto" />
        </button>
      );
    });
  };

  return (
    <>
      <div className="wrapper flex-1">
        {/* Create Game Section Starts Here */}
        <section className="relative w-full flex justify-center items-center lg:-mt-[0.4vw] -mt-1 bg-cover bg-center bg-[#D5F8FE]">
          <div
            className="w-full 2xl:min-h-[43.229vw] lg:min-h-[40vw] md:min-h-[45vw] min-h-[70vw] 2xl:pt-[10.41vw] md:pt-36 pt-24 flex justify-center items-center bg-no-repeat bg-bottom bg-[length:100%_auto] bg-primary-skyblue"
          // style={{ backgroundImage: `url(${SkyShapeBg})` }}
          >
            <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4 flex flex-col ">
              <img
                src={BannerLogo}
                alt="logo"
                className="2xl:h-[18.229vw] md:h-[240px] h-[150px] w-full object-contain"
              />
              <div className="2xl:max-w-[100vw] max-w-[940px] mx-auto w-full xl:mt-[3vw] lg:mt-14 md:mt-16 mt-10 landscape:max-lg:mt-4 xl:mb-[13vw] lg:mb-34 mb-55">
                <h6 className="font-bold 2xl:text-[1.25vw]/tight xl:text-2xl/tight text-lg/tight text-black-300 text-start w-full 2xl:mb-[0.41vw] xl:mb-2 mb-1">
                  {t("createGame.gameName")}
                </h6>
                <div
                  className="relative 2xl:py-[0.75vw] py-2 lg:px-[1.5625vw] px-4 flex
                        2xl:rounded-[0.26vw] rounded-[5px]
                        skew-x-[-10deg]
                        2xl:border-[0.104vw] border-[1.5px]
                        transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] bg-white"
                >
                  <input
                    ref={gameNameInputRef}
                    type="text"
                    placeholder={t("createGame.enterGameName")}
                    value={gameData.game_name}
                    onChange={(e) => updateGameName(e.target.value)}
                    className="2xl:mt-[0.208vw] mt-1 rtl:dir-rtl rtl:text-right w-full  2xl:text-[1.1vw]/none xl:text-lg md:text-base/none text-sm/none landscape:max-lg:text-sm/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent"
                  />
                </div>
                {errors.gameName && (
                  <p className="text-red-500 lg:text-[1vw] text-sm lg:mt-[0.208vw] mt-1 lg:px-[0.833vw] px-4 font-bold w-full">
                    {t(errors.gameName)}
                  </p>
                )}

                <div id="addteam" className="xl:my-[4.20vw] lg:my-20 md:my-11 my-7 landscape:max-lg:my-7">
                  <h3 className="xl:text-[2.5vw]/tight md:text-4xl/tight text-3xl/tight landscape:max-lg:text-3xl/tight text-primary-rose font-bold text-center">
                    {t("createGame.playingTeams")}
                  </h3>
                  <div className="xl:mt-[2.084vw] lg:mt-10 md:mt-5 mt-4 landscape:max-lg:mt-4">
                    <div className="flex lg:gap-[1.542vw] md:gap-6 gap-5 landscape:max-lg:gap-5 items-stretch">
                      {gameData?.teams?.map((team, index) => {
                        const isActive = selectedTeamIndex === index;
                        const canRemove = gameData.teams.length > MIN_TEAMS;
                        return (
                          <div
                            onClick={() => {
                              setSelectedTeam(team);
                              setSelectedTeamIndex(index);
                            }}
                            key={index}
                            className={`relative sm:w-[25%] w-[50%] min-w-0 flex flex-col 2xl:border-[0.079vw] border-[1.5px] border-black-300 2xl:rounded-[0.625vw] rounded-xl 2xl:p-[0.83vw] xl:p-4 sm:p-3 p-1 landscape:max-lg:p-4 shadow-[0px_4px_0px_0px_#110706] cursor-pointer
                            ${isActive ? activeClasses : `text-primary-orange  ${defaultBorder}`}`}
                          >
                            <button className="w-full flex-1 flex flex-col items-center justify-center min-w-0">
                              {/* <span className={`inline-block skew-x-[-8deg] bg-[#97A4F2] overflow-hidden rounded-sm 2xl:border-[0.15vw] border-2 2xl:w-[2.91vw] lg:w-14 w-10 2xl:h-[2.5vw] lg:h-12 h-9 mx-auto ${isActive ? 'border-primary-orange shadow-[0px_1.5px_0px_0px_#D76A4D]' : 'border-black-300 shadow-[0px_1.5px_0px_0px_#110706]'}`}>
                                <img src={team?.team_profile || team?.team_name} alt="" className="w-full h-full object-cover object-top" />
                              </span> */}
                              <span
                                className={`block w-full min-w-0 text-center font-bold landscape:max-lg:text-3xl/tight 2xl:text-[1.25vw] xl:text-xl/tight sm:text-lg/tight xs:text-base/tight text-sm/tight break-words overflow-hidden px-4 ${isActive ? "text-primary-orange" : "text-black-300"}`}
                              >
                                {team?.team_name || `Team ${index + 1}`}
                              </span>
                            </button>
                            {/* Edit Team Button - Pencil Icon */}
                            <button
                              onClick={(e) => handleEditTeam(index, e)}
                              className="absolute -2xl:top-2 -top-2 -2xl:start-2 -start-2 2xl:w-[1.667vw] 2xl:h-[1.667vw] w-6 h-6 flex items-center justify-center skew-x-[-10deg] bg-[#97A4F2] 2xl:border-[0.104vw] border-[1.5px] border-black-300 2xl:rounded-[0.26vw] rounded-[5px] 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] transition-all z-10 cursor-pointer hover:-translate-y-0.5"
                              aria-label="Edit team"
                            >
                              <svg
                                className="2xl:w-[0.833vw] 2xl:h-[0.833vw] w-4 h-4 text-white skew-x-[10deg]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2.5}
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                />
                              </svg>
                            </button>
                            {/* Remove Team Button - Cross Icon */}
                            {canRemove && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTeamToDelete(index);
                                }}
                                className="absolute -2xl:top-2 -top-2 -2xl:end-2 -end-2 2xl:w-[1.667vw] 2xl:h-[1.667vw] w-6 h-6 flex items-center justify-center skew-x-[-10deg] bg-primary-orange 2xl:border-[0.104vw] border-[1.5px] border-black-300 2xl:rounded-[0.26vw] rounded-[5px] 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] transition-all z-10 cursor-pointer hover:-translate-y-0.5"
                                aria-label="Remove team"
                              >
                                <svg
                                  className="2xl:w-[0.833vw] 2xl:h-[0.833vw] w-4 h-4 text-white skew-x-[10deg]"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2.5}
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        );
                      })}
                      {/* Add Team Button - Only show if less than MAX_TEAMS */}
                      {gameData.teams.length < MAX_TEAMS && (
                        <button
                          onClick={() => handleOpenModal()}
                          className="sm:w-[25%] w-[50%] 2xl:border-[0.079vw] border-[1.5px] border-[#888383] 2xl:rounded-[0.625vw] rounded-xl 2xl:p-[0.83vw] xl:p-4 sm:p-3 p-1 landscape:max-lg:p-1 shadow-[0px_4px_0px_0px_#888383] cursor-pointer flex justify-center items-center flex 2xl:gapy-[1.041vw] xl:gap-y-5 gap-y-3 bg-white"
                        >
                          <svg
                            className="2xl:w-[1.66vw] xl:w-8 w-6"
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.7143 18.2857H0V13.7143H13.7143V0H18.2857V13.7143H32V18.2857H18.2857V32H13.7143V18.2857Z"
                              fill="#888383"
                            />
                          </svg>
                          <span
                            className={`block text-center font-bold 2xl:text-[0.9375vw] xl:text-lg/tight sm:text-base/tight xs:text-sm/tight text-xs/tight landscape:max-lg:text-xs/tight 2xl:mt-[0.2vw] mt-1 text-[#888383] ml-2 rtl:ml-0 rtl:mr-2`}
                          >
                            {t("createGame.addTeam")}
                          </span>
                        </button>
                      )}
                    </div>
                  </div>

                </div>
              </div>
              {/* <div className="flex justify-center items-center w-full lg:gap-[1.042vw] gap-4 flex-wrap">
                <div className="flex items-center w-full lg:gap-[1.042vw] md:gap-4 gap-3 md:flex-row flex-col">
                  <div className="flex md:items-center items-start lg:justify-between justify-start lg:gap-[1.25vw] md:gap-4 gap-4 justify-between w-full lg:flex-row flex-col">

                  </div>
                </div>
                <div className="flex flex-col lg:gap-[0.833vw] gap-3 justify-center items-center w-full">
                </div>
              </div> */}
            </div>
          </div>
        </section >
        {/* Start Playing Section Ends Here */}
        {/* <section className="bg-white-500 top-curve-shape lg:h-[1.823vw] md:h-[35px] h-5 -scale-100 lg:-mb-[1.823vw] md:-mb-[35px] -mb-5"></section> */}

        {/* Select Categories Section Starts Here */}
        <section
          id="selectcategory"
          className="w-full flex justify-center items-center bg-primary-ivory 2xl:pb-[3.5vw] lg:pb-15 pb-10"
        >
          <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4 relative z-20 flex flex-col items-center justify-between xl:-mt-[18vw] -mt-55">
            <div className="flex flex-col w-full 2xl:mt-[10.5vw] xl:mt-48 md:mt-40 xs:mt-28 mt-20 landscape:max-lg:mt-35 2xl:mb-[6vw] sm:mb-20 mb-15">
              {/* Row 1: left bench = team 1, right bench = team 2 */}
              <div className="relative flex flex-wrap justify-between items-center w-full mt-10">
                {gameData.teams.length >= 1 && (
                  <div className="absolute start-[25%] -translate-x-1/2 2xl:-top-[5vw] xl:-top-20 md:-top-18 -top-16 z-10">
                    <p className="text-black-300 font-bold 2xl:text-[1.35vw]/tight xl:text-3xl/tight md:text-2xl/tight text-lg/tight text-center">
                      {gameData.teams[0]?.team_name}
                    </p>
                  </div>
                )}
                {gameData.teams.length >= 2 && (
                  <div className="absolute start-[75%] -translate-x-1/2 2xl:-top-[5vw] xl:-top-20 md:-top-18 -top-16 z-10">
                    <p className="text-black-300 font-bold 2xl:text-[1.35vw]/tight xl:text-3xl/tight md:text-2xl/tight text-lg/tight text-center">
                      {gameData.teams[1]?.team_name}
                    </p>
                  </div>
                )}
                <img src={BenchLeft} alt="" className="max-w-[50%] w-[50%] 2xl:h-[13.438vw] lg:h-[258px] md:h-[170px] sm:h-[120px] h-[87px] rtl:-scale-x-100" />
                <img src={BenchRight} alt="" className="max-w-[50%] w-[50%] 2xl:h-[13.438vw] lg:h-[258px] md:h-[170px] sm:h-[120px] h-[87px] rtl:-scale-x-100" />

                {user && !hasJoinedAnyTeam() && (
                  <img
                    src={standingCharacterUrl || (user?.gender === "female" ? GirlAvtarStandImg : AvtarOne)}
                    alt=""
                    className="absolute 2xl:w-[8vw] xl:w-[10vw] lg:w-[120px] md:w-[90px] sm:w-20 w-10 2xl:-top-[4vw] xl:-top-[70px] sm:-top-[50px] -top-5 start-[50%] -translate-x-[50%] rtl:translate-x-[50%] rtl:-scale-x-100"
                  />
                )}
                {!hasJoinedAnyTeam() && gameData?.teams?.length > 0 && (
                  <div className="absolute start-1/2 -translate-x-1/2 rtl:translate-x-1/2 2xl:-top-[8vw] xl:-top-[130px] md:-top-[130px] sm:-top-27 -top-18 flex justify-center">
                    <button
                      type="button"
                      onClick={handleJoinSelectedTeamAsHost}
                      className="cursor-pointer flex items-center justify-center
                      2xl:px-[0.417vw] 2xl:py-[0.208vw] px-2 py-1 2xl:text-[0.9vw]/tight md:text-xs/tight sm:text-[9px]/tight text-[8px]/tight font-bold text-white bg-primary-orange 2xl:rounded-[0.417vw] sm:rounded-lg rounded-sm  2xl:border-[0.104vw] border border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]"
                    >
                      {user?.full_name}
                      {" | IQ:"}
                      {user?.IQ}
                      <br />
                      {t("createGame.joinTeam.joinTeamToPlay")}
                    </button>
                  </div>
                )}
                {gameData.teams.length >= 1 && renderBenchSeatSlots(0, "fullRowLeft")}
                {gameData.teams.length >= 2 && renderBenchSeatSlots(1, "fullRowRight")}
              </div>

              {/* Exactly 3 teams: center bench = team 3 */}
              {gameData.teams.length === 3 && (
                <div className="w-full flex justify-center xl:mt-[8.5vw] md:mt-30 mt-30 xl:mb-[4vw] sm:mb-15 mb-10">
                  <div className="relative w-full lg:max-w-fit max-w-[70%] 2xl:h-[10.938vw] lg:h-[210px] md:h-[138px] sm:h-[97px] h-[70px]">
                    <div className="absolute start-1/2 -translate-x-1/2 2xl:-top-[5vw] xl:-top-20 md:-top-18 -top-16 z-10">
                      <p className="text-black-300 font-bold 2xl:text-[1.35vw]/tight xl:text-3xl/tight md:text-2xl/tight text-lg/tight text-center whitespace-nowrap">
                        {gameData.teams[2]?.team_name}
                      </p>
                    </div>
                    <img src={BenchCenter} alt="" className="w-full h-full" />
                    {renderBenchSeatSlots(2, "centerBench")}
                  </div>
                </div>
              )}

              {/* 4 teams: second row — team 3 left, team 4 right (no center bench) */}
              {gameData.teams.length === 4 && (
                <div className="relative flex flex-wrap justify-between items-center w-full xl:mt-[9.5vw] md:mt-[10vw] mt-30">
                  <div className="absolute start-[25%] -translate-x-1/2 2xl:-top-[5vw] xl:-top-20 md:-top-18 -top-16 z-10">
                    <p className="text-black-300 font-bold 2xl:text-[1.35vw]/tight xl:text-3xl/tight md:text-2xl/tight text-lg/tight text-center">
                      {gameData.teams[2]?.team_name}
                    </p>
                  </div>
                  <div className="absolute start-[75%] -translate-x-1/2 2xl:-top-[5vw] xl:-top-20 md:-top-18 -top-16 z-10">
                    <p className="text-black-300 font-bold 2xl:text-[1.35vw]/tight xl:text-3xl/tight md:text-2xl/tight text-lg/tight text-center">
                      {gameData.teams[3]?.team_name}
                    </p>
                  </div>
                  <img src={BenchLeft} alt="" className="max-w-[50%] w-[50%] 2xl:h-[13.438vw] lg:h-[258px] md:h-[170px] sm:h-[120px] h-[87px] rtl:-scale-x-100" />
                  <img src={BenchRight} alt="" className="max-w-[50%] w-[50%] 2xl:h-[13.438vw] lg:h-[258px] md:h-[170px] sm:h-[120px] h-[87px] rtl:-scale-x-100" />
                  {renderBenchSeatSlots(2, "fullRowLeft")}
                  {renderBenchSeatSlots(3, "fullRowRight")}
                </div>
              )}

            </div>
            <h1 className="xl:text-[2.5vw]/tight md:text-4xl/tight text-3xl/tight landscape:max-lg:text-3xl/tight text-primary-rose font-bold text-center">
              <span className="block text-charcoal font-semibold">{t("createGame.selectCategories")}</span>
            </h1>

            {/* Category Count Selection */}
            <div className="flex flex-col items-center gap-3 xl:mt-[2.084vw] lg:mt-10 md:mt-5 mt-4 landscape:max-lg:mt-4 w-full">
              <p className="2xl:text-[1.042vw] md:text-lg text-base font-semibold text-black-300 text-center mb-2">
                {t("createGame.howManyCategories") || "How many categories do you want?"}
              </p>
              <div className="flex lg:gap-[1.042vw] md:gap-4 gap-2 w-full justify-center flex-wrap">
                {[4, 6, 8, 10].map((count) => {
                  const isDisabled = isFreeTrial && count !== 6;
                  return (
                    <button
                      key={count}
                      disabled={isDisabled}
                      onClick={() => {
                        if (isDisabled) return;
                        setSelectedCategoryCount(count);
                        // Preserve existing selections and only trim overflow when reducing count.
                        setSelectedCategories((prev) => prev.slice(0, count));
                        setGameData((prev) => ({
                          ...prev,
                          game_categories: prev.game_categories.slice(0, count),
                        }));
                      }}
                      className={`flex items-center justify-center 2xl:min-w-[8.333vw] lg:min-w-[160px] md:min-w-[140px] min-w-[80px] 2xl:min-h-[2.5vw] min-h-[50px] 2xl:rounded-[0.26vw] rounded-[5px] h-full skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.042vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold transition-all duration-200 text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] ${isDisabled
                        ? "opacity-50 cursor-not-allowed text-gray-400 bg-gray-200 border-gray-400"
                        : selectedCategoryCount === count
                          ? "text-primary-yellow bg-primary-yellow border-black-300 cursor-pointer"
                          : "text-black-300 bg-primary-yellow border-black-300 cursor-pointer"
                        }`}
                    >
                      <span
                        className={`2xl:pt-[0.7vw] md:pt-2.5 pt-3 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] md:py-2.5 py-3 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 w-full skew-x-[-0deg] block ${isDisabled
                          ? "bg-gray-100 text-gray-400"
                          : selectedCategoryCount === count
                            ? "bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] text-white"
                            : "bg-white"
                          }`}
                      >
                        {count}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Random toggle: one button only; click = random, click again = manual */}
            <div className="flex flex-col items-center gap-3 xl:mt-[2.084vw] lg:mt-10 md:mt-5 mt-4 landscape:max-lg:mt-4 w-full mb-7 md:mt-10">
              <div className="flex lg:gap-[1.042vw] md:gap-4 gap-2 w-full justify-center">
                {!isRandomMode ? (
                  <SecondaryBtn
                    onClick={() => {
                      lastRandomizedRef.current = null;
                      setIsRandomMode(true);
                    }}
                    className={`mb-0 w-full ${gameData.teams.length < MIN_TEAMS ? "opacity-80 cursor-not-allowed" : ""}`}
                    disabled={gameData.teams.length < MIN_TEAMS}
                  >
                    {t("createGame.random")}
                  </SecondaryBtn>
                ) : (
                  <>
                    <PrimaryBtn
                      onClick={() => {
                        lastRandomizedRef.current = null;
                        setSelectedCategories([]);
                        setGameData((prev) => ({
                          ...prev,
                          game_categories: [],
                        }));
                        setIsRandomMode(false);
                      }}
                      className="mb-0 w-full"
                    >
                      {t("createGame.random")}
                    </PrimaryBtn>
                    {isRandomMode && gameData.teams.length >= MIN_TEAMS && (
                      <PrimaryBtn onClick={randomizeCategories} className="w-fit">
                        <span className="flex items-center  justify-center px-2">
                          <svg
                            className="w-5 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                          </svg>
                          {/* {t("createGame.shuffleCategories")} */}
                        </span>
                      </PrimaryBtn>
                    )}
                  </>
                )}

                <div className="hidden md:flex justify-center items-center w-full 2xl:max-w-[32.6vw] max-w-[626px]  2xl:mb-[2.5vw] xl:mb-10 lg:mb-9 md:mb-8 mb-6 ">
                  <div
                    className="relative w-full landscape:max-lg:py-3 landscape:max-xl:py-4 2xl:py-[0.70vw] md:py-2.5 py-3 lg:px-[1.5625vw] px-4 flex
                        2xl:rounded-[0.26vw] rounded-[5px]
                        skew-x-[-10deg]
                        2xl:border-[0.104vw] border-[1.5px]
                        transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] bg-white"
                  >
                    <input
                      type="search"
                      placeholder={t("createGame.searchCategory")}
                      value={categorySearch}
                      onChange={(e) => setCategorySearch(e.target.value)}
                      className="2xl:mt-[0.208vw] md:mt-0 mt-0 rtl:dir-rtl rtl:text-right w-full  2xl:text-[1.1vw]/none xl:text-lg md:text-base/none text-sm/none landscape:max-lg:text-xl/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent"
                    />
                  </div>
                </div>
              </div>
              <div className="flex md:hidden justify-center items-center w-full 2xl:max-w-[32.6vw] max-w-[626px]  2xl:mb-[2.5vw] xl:mb-10 lg:mb-9 md:mb-8 mb-6 ">
                <div
                  className="relative w-full 2xl:py-[0.75vw] md:py-2.5 py-3 lg:px-[1.5625vw] px-4 flex
                        2xl:rounded-[0.26vw] rounded-[5px]
                        skew-x-[-10deg]
                        2xl:border-[0.104vw] border-[1.5px]
                        transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] bg-white"
                >
                  <input
                    type="search"
                    placeholder={t("createGame.searchCategory")}
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    className="2xl:mt-[0.208vw] md:mt-0 mt-0 rtl:dir-rtl rtl:text-right w-full  2xl:text-[1.1vw]/none xl:text-lg md:text-base/none text-sm/none landscape:max-lg:text-sm/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent"
                  />
                </div>
              </div>

              {/* Shuffle button - only show in random mode */}
            </div>

            <div ref={categoryContainerRef} className="xl:px-0 md:px-10 px-4">
              {categoryListLoading ? (
                <div className="flex justify-center items-center w-full h-[50vh]">
                  <Loader />
                </div>
              ) : categories.length === 0 && categorySearch.trim() !== "" ? (
                <div className="flex flex-col justify-center items-center w-full xl:mt-[1.5vw] lg:mt-10 md:mt-10 mt-9 landscape:max-lg:mt-8 py-12">
                  <p className="2xl:text-[1.25vw]/tight xl:text-2xl/tight text-lg/tight font-bold text-black-400 text-center">
                    {t("createGame.error.noCategoriesFoundWithSearch", { text: categorySearch })}
                  </p>
                  {/* <p className="2xl:text-[0.938vw]/tight xl:text-lg/tight md:text-base/tight text-sm/tight font-medium text-black-400 text-center mt-2">
                    {t("createGame.error.tryDifferentSearch")}
                  </p> */}
                </div>
              ) : (
                <>
                  <div className="w-full flex flex-col gap-6 items-stretch 2xl:mt-[1vw] mt-2">
                    {masterCategories.map((master: any) => {
                      const isOpen = expandedMasterIds.includes(master.id);

                      return (
                        <div key={master.id} className="w-full self-stretch border-2 rounded-3xl border-black-300 bg-[#E7E7E7] relative p-2 md:mt-2 mt-3">
                          <button
                            type="button"
                            onClick={() => {
                              setExpandedMasterIds((prev) =>
                                prev.includes(master.id) ? prev.filter((id) => id !== master.id) : [...prev, master.id]
                              );
                            }}
                            className="absolute start-0 2xl:-top-9 -top-7 w-full flex items-center justify-center 2xl:pt-[0.55vw]"
                          >
                            <span className="inline-flex items-center justify-center bg-primary-orange text-white border-2 border-primary-orange rounded-full 2xl:min-h-[3.2vw] min-h-[24px] md:min-h-[52px] md:px-12 px-6 2xl:px-[3.5vw] 2xl:py-[0.55vw] py-2 2xl:text-[1.65vw]/tight text-xl/tight md:text-2xl/tight font-bold wrap-break-word max-w-[min(92vw,48rem)] text-center">
                              {master.name}
                            </span>
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setExpandedMasterIds((prev) =>
                                prev.includes(master.id) ? prev.filter((id) => id !== master.id) : [...prev, master.id]
                              );
                            }}
                            className="flex items-center justify-center absolute landscape:max-lg:start-2 landscape:max-lg:top-2 landscape:max-xl:start-2 landscape:max-xl:top-2 start-2 top-2 sm:start-5 sm:top-3 md:start-2 md:top-2 bg-black-100 border-[1.5px] rounded-full 2xl:w-[1.8vw] 2xl:h-[1.8vw] sm:w-8 sm:h-8 w-5 h-5 text-black-300 bg-[#fffba1]"
                            aria-label={isOpen ? "Collapse category group" : "Expand category group"}
                          >
                            <svg
                              className="2xl:w-[0.9vw] 2xl:h-[0.9vw] sm:w-4 sm:h-4 w-3 h-3"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                d="M3 8H13"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              {!isOpen && (
                                <path
                                  d="M8 3V13"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                />
                              )}
                            </svg>
                          </button>
                          <div
                            className={`grid transition-all duration-300 ease-in-out w-full ${isOpen
                              ? "grid-rows-[1fr] opacity-100 mt-2 pointer-events-auto"
                              : "grid-rows-[0fr] opacity-0 mt-5 sm:mt-0 pointer-events-none"
                              }`}
                          >
                            <div className="w-full overflow-hidden rounded-3xl 2xl:px-[1vw] px-3 2xl:py-[1vw] py-2.5 md:py-4">
                              <div className="grid w-full grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-x-3 gap-y-4 md:mt-8 lg:mt-12 xl:mt-[1.6vw] landscape:max-lg:mt-6 2xl:gap-x-[0.833vw] 2xl:gap-y-[1.25vw] justify-items-stretch">
                                {master.categories.map((item: any) => {
                                  const isSelected = selectedCategories.includes(item.id);
                                  const atCategoryLimit =
                                    selectedCategoryCount !== null &&
                                    selectedCategories.length >= selectedCategoryCount;
                                  const isDisabled = atCategoryLimit && !isSelected;

                                  return (
                                    <div
                                      key={item.id}
                                      onClick={() => !isDisabled && toggleCategorySelection(item.id)}
                                      className={`relative h-auto w-full transition-all duration-300 group ${isDisabled ? "opacity-70 cursor-not-allowed" : "cursor-pointer hover:z-[101]"} ${isSelected && activeCategoryClasses}`}
                                    >
                                      <img
                                        // src={isSelected ? item?.image_selected || item?.image : item?.image}
                                        src={item?.image}
                                        alt=""
                                        className="h-full w-full object-contain"
                                      />

                                      {/* {item?.isPlayed && (
                                        <span className="absolute top-1 start-1 z-20 rounded-[4px] border-[1.5px] border-black-300 bg-primary-yellow px-1.5 py-0.5 text-[10px] font-bold leading-tight text-black-300 shadow-[0px_2px_0px_#110706] sm:top-2 sm:start-2 sm:px-2 sm:py-1 sm:text-xs 2xl:top-[0.4vw] 2xl:start-[0.4vw] 2xl:rounded-[0.2vw] 2xl:border-[0.104vw] 2xl:px-[0.4vw] 2xl:py-[0.15vw] 2xl:text-[0.7vw] 2xl:shadow-[0px_0.156vw_0px_#110706]">
                                          {t("createGame.played")}
                                        </span>
                                      )} */}

                                      {item?.description && (
                                        <>
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setVisibleCategoryDescriptionId((current) => (current === item.id ? null : item.id));
                                            }}
                                            className="absolute bottom-2 end-2.5 z-20 flex h-6 w-6 items-center justify-center rounded-full border-[1.5px] border-black-300 bg-primary-yellow shadow-[0px_2px_0px_#110706] transition-all hover:scale-102 sm:bottom-3 sm:end-4 sm:h-8 sm:w-8 md:bottom-4 md:end-6 md:h-10 md:w-10 landscape:max-lg:bottom-[0.5vw] landscape:max-lg:end-[0.5vw] landscape:max-lg:h-[3vw] landscape:max-lg:w-[3vw] landscape:max-xl:bottom-[1vw] landscape:max-xl:end-[1.1vw] 2xl:bottom-[0.5vw] 2xl:end-[0.5vw] 2xl:h-[2vw] 2xl:w-[2vw] 2xl:rounded-full 2xl:border-[0.104vw] 2xl:shadow-[0px_0.156vw_0px_#110706]"
                                            aria-label="Category information"
                                          >
                                            <IoInformation className="h-full w-full text-black-300" />
                                          </button>

                                          {visibleCategoryDescriptionId === item.id && (
                                            <div className="absolute bottom-2 end-2.5 z-10 max-h-32 overflow-y-auto rounded-[6px] border-[1.5px] border-black-300 bg-primary-yellow px-2 py-2 text-xs text-black-300 shadow-[0px_2px_0px_#110706] sm:bottom-3 sm:end-4 sm:max-h-32 sm:text-sm md:bottom-16 md:end-6 md:max-h-40 md:rounded-[8px] md:px-3 md:py-2.5 2xl:bottom-[2.2vw]">
                                              <p className="mb-1 break-words font-semibold sm:text-[14px] md:text-[15px]">{item.categoryTitle}</p>
                                              <p className="break-words font-medium text-[13px]">{item.description}</p>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Loading more indicator */}
                  {isLoadingMore && (
                    <div className="flex justify-center items-center w-full py-8">
                      <Loader />
                    </div>
                  )}
                </>
              )}
            </div>

          </div>
        </section>
        {/* Select Categories Section Ends Here */}

        <div id="lifeline-selection">
          <SpinWheelModal
            isCreatingGame={isCreatingGame}
            isOpen={true}
            embedded={true}
            onClose={() => undefined}
            lifelines={lifelines || []}
            teams={gameData?.teams || []}
            lifelinesPerTeam={3}
            lifelineEnabled={isLifelineEnabled}
            onLifelineEnabledChange={(enabled) => {
              setIsLifelineEnabled(enabled);
              if (!enabled) {
                setGameData((current) => ({
                  ...current,
                  teams: current.teams.map((team) => ({ ...team, lifelines: [] })),
                }));
              }
            }}
            onComplete={handleLifelinesComplete}
          />
        </div>

        <div className="w-full flex justify-center items-center bg-primary-ivory">



          <PrimaryBtn
            onClick={handleCreateGame}
            className="2xl:min-w-[21.667vw] xl:min-w-[416px] sm:min-w-64"
            disabled={isCreatingGame}
          >
            {isCreatingGame ? (
              <div className="flex items-center justify-center">
                <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              t("createGame.startGame")
            )}
          </PrimaryBtn>
        </div>
      </div >

      {/* Selected Categories Sticky Panel */}
      <SelectedCategoriesPanel
        selectedCategories={selectedCategories}
        categories={categories}
        onRemoveCategory={toggleCategorySelection}
        onClearAll={() => setIsClearCategoriesModalOpen(true)}
        currentLanguage={currentLanguage}
      />

      {isJoinTeamSelectOpen && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
          <div className="bg-white-500 lg:rounded-[1.5vw] rounded-3xl 2xl:p-[2vw] md:p-8 p-6 2xl:max-w-[35vw] md:max-w-[600px] max-w-[90%] w-full relative lg:border-[0.2vw] border-3 border-primary overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
            <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full lg:mb-[1vw] mb-3">
              <h1 className="2xl:text-[1.563vw]/[1.7vw] xl:text-3xl/tight text-2xl/6 font-semibold text-primary-orange">
                {t("createGame.joinTeam.selectTeamTitle")}
              </h1>
              <button
                onClick={() => setIsJoinTeamSelectOpen(false)}
                className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300 outline-none"
              >
                <svg
                  className="w-full h-full"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                    fill="#333938"
                  />
                </svg>
              </button>
            </div>

            <div className="lg:space-y-[0.833vw] space-y-4 lg:mb-[1.042vw] md:mb-6 mb-4">
              <p className="2xl:text-[1.12vw]/tight text-lg/tight font-bold text-black-300 text-center">
                {t("createGame.joinTeam.selectTeamDescription")}
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {gameData.teams.map((team, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleConfirmJoinTeam(index)}
                  className="w-full 2xl:rounded-[0.26vw] rounded-[5px] h-full flex items-center justify-between 2xl:border-[0.104vw] border-[1.5px] lg:text-[1.1vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-black-300 bg-primary-ivory border-black-300 transition-all duration-200 cursor-pointer text-left hover:-translate-y-0.5 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] px-4 py-3"
                >
                  <span>
                    {team.team_name ||
                      t("createGame.teamParticipantModal.team", {
                        index: index + 1,
                      })}
                  </span>
                  <span className="text-sm text-black-400">
                    {team.participants.length}/{MAX_PARTICIPANTS_PER_TEAM}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {
        activeTeamModal !== null && (
          <TeamParticipantModals
            roomName={roomName || ""}
            isOpen={activeTeamModal !== null}
            onClose={() => setActiveTeamModal(null)}
            teamIndex={activeTeamModal ?? 0}
            teamName={
              activeTeamModal !== null
                ? gameData.teams[activeTeamModal]?.team_name ||
                t("createGame.teamParticipantModal.team", { index: activeTeamModal + 1 })
                : ""
            }
            participants={activeTeamModal !== null ? gameData.teams[activeTeamModal]?.participants || [] : []}
            onUpdateParticipants={(participants) => {
              if (activeTeamModal !== null) {
                updateTeamParticipants(activeTeamModal, participants);
              }
            }}
            otherTeamsParticipants={
              activeTeamModal !== null
                ? gameData?.teams?.filter((_, index) => index !== activeTeamModal).flatMap((team) => team.participants)
                : []
            }
          />
        )
      }

      {
        isModalOpen && (
          <AddTeam
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onAddTeam={(teamName) => {
              if (editingTeamIndex !== null) {
                // Editing existing team
                let updatedTeam: Team | null = null;
                setGameData((prev) => {
                  const newTeams = [...prev.teams];
                  updatedTeam = {
                    ...newTeams[editingTeamIndex],
                    team_name: teamName,
                    team_profile: "",
                  };
                  newTeams[editingTeamIndex] = updatedTeam;
                  return { ...prev, teams: newTeams };
                });
                // Update selectedTeam if it's the one being edited
                if (editingTeamIndex === selectedTeamIndex && updatedTeam) {
                  setSelectedTeam(updatedTeam);
                }
              } else {
                // Adding new team
                if (gameData.teams.length >= MAX_TEAMS) {
                  useToast(`Maximum ${MAX_TEAMS} teams allowed`, "error");
                  return;
                }
                let newTeam: Team | null = null;
                let newTeamIndex: number = 0;
                setGameData((prev) => {
                  const newTeams = [...prev.teams];
                  newTeam = {
                    team_name: teamName,
                    participants: [],
                    lifelines: [],
                    team_profile: "",
                  };
                  newTeams.push(newTeam);
                  newTeamIndex = newTeams.length - 1; // Index of the newly added team
                  return { ...prev, teams: newTeams, number_of_teams: newTeams.length };
                });
                // Select the newly added team
                if (newTeam) {
                  setSelectedTeamIndex(newTeamIndex);
                  setSelectedTeam(newTeam);
                }
              }
              setIsModalOpen(false);
              setEditingTeamIndex(null);
            }}
            initialTeamName={editingTeamIndex !== null ? gameData.teams[editingTeamIndex]?.team_name : undefined}
            teamNumber={editingTeamIndex !== null ? editingTeamIndex + 1 : gameData.teams.length + 1}
            existingTeamNames={gameData.teams.map(team => team.team_name)}
            editingTeamIndex={editingTeamIndex}
          />
        )
      }

      {
        isBuyCreditsModalOpen && (
          <BuyCreditsModal isOpen={isBuyCreditsModalOpen} onClose={() => setIsBuyCreditsModalOpen(false)} />
        )
      }

      {
        teamToDelete !== null && (
          <DeleteTeamModal
            isOpen={teamToDelete !== null}
            onClose={handleCancelDeleteTeam}
            onConfirm={handleConfirmDeleteTeam}
            teamName={teamToDelete !== null ? gameData.teams[teamToDelete]?.team_name || "" : ""}
          />
        )
      }

      {
        participantToDelete !== null && (
          <DeleteParticipantModal
            isOpen={participantToDelete !== null}
            onClose={handleCancelDeleteParticipant}
            onConfirm={handleConfirmDeleteParticipant}
            participantName={participantToDelete?.name || ""}
          />
        )
      }

      {
        isClearCategoriesModalOpen && (
          <ClearCategoriesModal
            isOpen={isClearCategoriesModalOpen}
            onClose={() => setIsClearCategoriesModalOpen(false)}
            onConfirm={handleClearAllCategories}
          />
        )
      }
    </>
  );
};

export default CreateGame;
